export default function NoInternetConnectionPage({ isConnected }: { isConnected: boolean }) {
  const handleReload = () => {
    if (isConnected) {
      window.location.reload()
    }
  }

  return (
    <section>
      <div className="h-screen w-screen bg-linear-to-b from-gray-50 to-gray-100">
        <div className="h-full w-full max-w-md mx-auto px-4">
          <div className="flex flex-col justify-center items-center h-full w-full">
            <div className="flex flex-col justify-center items-center">
              <img src="/vibrato-logo-alt.svg" className="h-[40px] lg:h-[60px] min-w-fit mb-6" />

              <div className="relative w-24 h-24 mb-6">
                <div className="absolute inset-0 bg-red-50 rounded-full flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="text-red-500"
                  >
                    <line x1="1" y1="1" x2="23" y2="23" />
                    <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55" />
                    <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39" />
                    <path d="M10.71 5.05A16 16 0 0 1 22.58 9" />
                    <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
                    <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
                    <line x1="12" y1="20" x2="12.01" y2="20" />
                  </svg>
                </div>
              </div>

              <div className="text-2xl font-bold text-gray-800 text-center">No Internet Connection</div>
              <div className="text-base font-normal text-gray-600 mt-3 max-w-md text-center mx-auto">
                We couldn&apos;t connect to Vibrato. Please check your internet connection and try again.
              </div>

              <div className="mt-8 w-full max-w-xs">
                <button
                  onClick={handleReload}
                  className="w-full py-3.5 px-4 rounded-lg bg-blue-600 text-white font-medium flex items-center justify-center gap-2 transition-all hover:bg-blue-700 active:scale-98 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-lg shadow-blue-500/20"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38" />
                  </svg>
                  Retry Connection
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
